import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocale } from '../../i18n/locale-context.js';
const RETENTION_OPTIONS = [
    {
        kind: 'raw-data-prohibited',
        labelKey: 'consent.retention.option.raw_data_prohibited.label',
        descriptionKey: 'consent.retention.option.raw_data_prohibited.description',
    },
    {
        kind: 'patient-level-derived-permitted',
        labelKey: 'consent.retention.option.patient_level_derived_permitted.label',
        descriptionKey: 'consent.retention.option.patient_level_derived_permitted.description',
    },
    {
        kind: 'aggregated-outputs-permitted',
        labelKey: 'consent.retention.option.aggregated_outputs_permitted.label',
        descriptionKey: 'consent.retention.option.aggregated_outputs_permitted.description',
    },
];
function describeTimeBounds(tb, t) {
    switch (tb.kind) {
        case 'open-ended-until-revocation':
            return t('consent.time_bounds.until_revoke');
        case 'bounded-period':
            return t('consent.time_bounds.bounded_period_template', { until: tb.until });
        case 'per-operation-single-use':
            return t('consent.time_bounds.per_operation_single_use');
    }
}
export function RetentionReviewStep(props) {
    const { t } = useLocale();
    return (_jsxs("section", { "aria-labelledby": "retention-heading", children: [_jsx("h3", { id: "retention-heading", children: t('consent.retention.heading') }), _jsx("p", { children: t('consent.retention.body_template', {
                    discipline: props.requestedRetentionDiscipline,
                    timeBounds: describeTimeBounds(props.requestedTimeBounds, t),
                }) }), _jsx("h4", { children: t('consent.retention.discipline_heading') }), _jsx("ul", { "aria-label": t('consent.retention.disciplines_aria_label'), children: RETENTION_OPTIONS.map((opt) => (_jsx("li", { children: _jsxs("label", { children: [_jsx("input", { type: "radio", name: "retention-discipline", value: opt.kind, checked: props.currentRetentionDiscipline === opt.kind, onChange: () => props.onNarrow({
                                    retentionDiscipline: opt.kind,
                                    timeBounds: props.currentTimeBounds,
                                }) }), ' ', _jsx("strong", { children: t(opt.labelKey) }), " \u2014 ", t(opt.descriptionKey)] }) }, opt.kind))) }), _jsx("h4", { children: t('consent.retention.time_bounds_heading') }), _jsx("p", { children: t('consent.retention.time_bounds_body_template', {
                    timeBounds: describeTimeBounds(props.currentTimeBounds, t),
                }) }), _jsx("button", { type: "button", onClick: () => props.onNarrow({
                    retentionDiscipline: props.currentRetentionDiscipline,
                    timeBounds: { kind: 'per-operation-single-use' },
                }), children: t('consent.retention.shorten_to_single_use_button') }), _jsxs("div", { role: "group", "aria-label": t('consent.retention.actions_aria_label'), children: [_jsx("button", { type: "button", onClick: props.onContinue, children: t('consent.retention.continue') }), _jsx("button", { type: "button", onClick: props.onCancel, children: t('consent.retention.cancel') })] })] }));
}
//# sourceMappingURL=retention-review-step.js.map